import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class TitleService {

  public static title$: ReplaySubject<any> = new ReplaySubject<any>(0);

  get title(): Observable<string> {
    return TitleService.title$.asObservable();
  }
}
